import React, { ReactNode, FC } from 'react';
import Popup from '../Popup/Index';
import './Index.scss';

interface CompetenciesPopupProps {
  title: string;
  description?: string;
  children: ReactNode;
  footer?: ReactNode;
  onClose: () => void;
  className?: string;
  showCloseButton?: boolean;
  closeOnOverlayClick?: boolean;
}

const CompetenciesPopup: FC<CompetenciesPopupProps> = ({
  title,
  description,
  children,
  footer,
  onClose,
  className,
  showCloseButton = true,
  closeOnOverlayClick = true
}) => (
  <Popup
    title={title}
    description={description}
    onClose={onClose}
    className={
      className ? `${className} competencies-popup` : 'competencies-popup'
    }
    showCloseButton={showCloseButton}
    closeOnOverlayClick={closeOnOverlayClick}
  >
    <div className="competencies-popup-content">
      <div className="competencies-popup-scrollable">{children}</div>
      <div className="competencies-popup-footer">{footer}</div>
    </div>
  </Popup>
);

export default CompetenciesPopup;
